import React, {Fragment, PureComponent} from "react";
import {replace} from 'connected-react-router';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import Icon from '../../../../icons/Icon';
import UiIcon from "../../../../uq-ui/components/ui-icon";

import styles from "./style.css";
import {createClassNames} from "../../../../../infrastructure/helpers";
import {resetForm} from "../../../store/create-llama/actions";
import {setSidebarVisibility} from '../../../../layout/store/actions';

interface IStickersComponentsScannerHeaderProps {
    onBack: any;
    showBackBtn: boolean;
    theme: string;
    title: string;
    showLogo?: boolean;
}

interface ISStickersComponentsScannerHeaderDispatchProps {
    setSidebarVisibility: (visible: boolean) => Promise<void>;
    showBackBtn: boolean;
    theme: string;
    title: string;
}

type IProps = IStickersComponentsScannerHeaderProps & ISStickersComponentsScannerHeaderDispatchProps


class StickersComponentsScannerHeader extends PureComponent<IProps, {}> {

    static defaultProps = {
        onBack: () => {
        },
        showBackBtn: false,
        theme: 'white',
    };

    static propTypes = {
        onBack: PropTypes.func,
        showBackBtn: PropTypes.bool,
        theme: PropTypes.string,
        title: PropTypes.string.isRequired,
        showLogo: PropTypes.bool
    };

    onHamburgerPressed = () => {
        this.props.setSidebarVisibility(true);
    };

    // On the page background the controls are dark in the base theme and
    // light in the memorial theme; over media they are always light.
    renderBack = (onPage: boolean) => {
        return (
            <button type="button"
                    onClick={this.props.onBack}
                    className={styles.headerBackBtn}>
                <UiIcon name="back" size={24} rtl={true} color={onPage ? 'var(--c-icon)' : '#FFFFFF'}/>
            </button>
        );
    }

    renderHumburger(onPage: boolean) {
        return <Fragment>
            <UiIcon name="menu" size={26} color={onPage ? 'var(--c-icon)' : '#FFFFFF'}
                    onClick={this.onHamburgerPressed} className={styles.humburger}/>
        </Fragment>;
    }

    render() {
        const onPage = this.props.theme === 'brand';
        const containerStyles = [styles.container, onPage ? styles.containerOnPage : styles.containerOverMedia];
        const titleStyles = [styles.title, onPage ? styles.titleBrand : styles.titleWhite];
        return (
            <div className={createClassNames(containerStyles)}>
                {this.props.showBackBtn && this.renderBack(onPage)}
                <div></div>
                <div className={createClassNames(titleStyles)}>
                    {this.props.showLogo ? (
                        // light purple on greeting, white on memorial; CSS picks by theme
                        <Fragment>
                            <Icon name="LogoPurple" className="theme-base-only"/>
                            <Icon name="LogoWhite" className="theme-memorial-only"/>
                        </Fragment>
                    ) : this.props.title}
                </div>
                {this.renderHumburger(onPage)}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetForm: () => dispatch(resetForm()),
        goHome: () => dispatch(replace('/')),
        setSidebarVisibility: (visible) => dispatch(setSidebarVisibility(visible))
    };
};

export default compose(
    connect(null, mapDispatchToProps),
    withTranslation('cmp-scanner-header'),
)(StickersComponentsScannerHeader);
